var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionsXl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 18,
  viewBox: "0 0 13 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 0c.552 0 .836.426.644.926L6.039 7.698l5.83-1.21c.546-.112.988.252.988.794v.768c0 .36-.189.715-.472.95q-.075.11-.179.232L4.731 18h-.285c-.553 0-.846-.41-.65-.93l2.508-6.662-5.316 1.103C.442 11.624 0 11.26 0 10.718V9.95c0-.312.142-.62.364-.849q.09-.166.253-.366L7.714 0z"
})));
export default SvgActionsXl;